import Styles from '../WizardsDrawerV4.module.scss'
import { LevelCard, LevelProps, WizardOrLevelCard, Wizard } from '../Types'
import { WizardCard } from '../WizardCard/WizardCard'
import { ContentCard } from 'screens/blaze/Home/MobileHome/ContentCard/ContentCard'
import cx from 'classnames'
import { Button } from 'blaze-ui/Button/Button'
import { Icon } from 'almanac-ui/icons/Types'
import { WizardOpener } from '../WizardOpener/WizardOpener'

type AlternativeAction = {
  altWizard: Wizard
  label: string
  icon?: Icon
}

type Props = LevelProps & {
  heading?: string
  cards: WizardOrLevelCard[]
  cardSize?: 'small' | 'big'
  imgScale?: number
  textWidth?: string | number
  className?: string
  alternativeAction?: AlternativeAction
}

export const LevelPage = (props: Props) => {
  const { heading, cards, imgScale, textWidth, handleLevel, cardSize = 'big', className, alternativeAction } = props

  const cardClassName = cardSize === 'big' ? Styles.big : undefined

  const showAltButton = alternativeAction
  const AltButtonIcon = alternativeAction?.icon

  return (
    <>
      <h1>{heading || 'What do you want to make?'}</h1>

      <div className={cx(Styles.cardSection, className)}>
        {cards.map((card) => {
          if (card.wizard) {
            return (
              <WizardCard
                className={cx(cardClassName, Styles.contentCard)}
                imgScale={imgScale}
                textWidth={textWidth}
                key={card.title}
                {...card}
              />
            )
          }

          return (
            <ContentCard
              className={cx(cardClassName, Styles.contentCard)}
              key={card.title}
              {...card}
              onPress={handleLevel((card as LevelCard).level)}
            />
          )
        })}
      </div>
      {showAltButton && alternativeAction && (
        <div className={Styles.alternativeButtonContainer}>
          <WizardOpener type={alternativeAction.altWizard}>
            <Button size="lg" variant="tertiary" frontIcon={AltButtonIcon} fullWidth>
              {alternativeAction.label}
            </Button>
          </WizardOpener>
        </div>
      )}
    </>
  )
}
